<style scoped>
ul {
  list-style: none;
  padding-left: 1em;
}


</style>
<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { notify } from '@/helpers/notify' 


export default {
    page: {
        title: "Yetkilendirmeler",
        meta: [{ name: "description", content: appConfig.description }],
    },
    components: { Layout, PageHeader },
    data() {
        return {
            title: "YETKİLENDİRMELER",
            form: [],
            list: {},
            group_name: '',
            abilities: {},
            submitted:false,
            items: [ { text: "ANASAYFA", href: "/" }, { text: "YETKİLENDİRMELER", active: true } ],
            collapse:[],
            update_id:null
        };
    },
    created(){
        this.$http.post(`/abilites`) 
        .then(response => this.abilities = response.data)

        this.$http.get(`/abilites/groups`)
        .then(response => this.list = response.data)
    },
    methods:{
        findParentId(data, subId) {
            for (const item of data) {
                if (item.sub && item.sub.some(subItem => subItem.id === subId)) {
                return item.id;
                }
            }
            return 0; // Bulunamazsa 0
        },

        handleCheckboxChange(subId) {
            const parentId = this.findParentId(this.abilities, subId); // menuData senin yukarıdaki JSON

            // Sub ID'yi kontrol et
            if (this.form.includes(subId)) {
                // Eğer subId zaten listede varsa, çıkar
                this.form = this.form.filter(id => id !== subId);
            } else {
                // Eğer subId listede yoksa, ekle
                this.form.push(subId);
            }

            // Parent ID'yi kontrol et
            if (this.form.includes(subId) && !this.form.includes(parentId)) {
                // Eğer subId ekli ve parentId listede yoksa, parentId ekle
                this.form.push(parentId);
            } else if (!this.form.includes(subId) && this.form.includes(parentId)) {
                // Eğer subId çıkarıldı ve parentId artık listede değilse, parentId'yi çıkar
                const stillHasSub = this.abilities.find(item => item.id === parentId)
                    ?.sub.some(subItem => this.form.includes(subItem.id));

                if (!stillHasSub) {
                    this.form = this.form.filter(id => id !== parentId);
                }
            }
        },


        update(idx){
            this.form = []

            this.group_name = this.list[idx].name
            this.update_id = this.list[idx].id

            this.list[idx].abilities.map(e =>{
                this.form.push(e.id)
            })

            this.tumunuAc()
        },

        handle(yeni) {
            this.submitted = true;
            let new_data = (yeni ? true : false);

            this.$http.post('/abilites/store', { abilites:this.form, new_data, update_id:this.update_id, group_name:this.group_name})
            .then(response => {
                this.submitted = false;
                if(response.data.error){
                    return notify.error(response.data.message)
                }
                notify.success(response.data.message)
            })

            
                    
            this.$http.get(`/abilites/groups`).then(response => this.list = response.data)

            this.form = []
            this.collapse = [0]
                    
        },

        _collapse(idx){
            if (this.collapse.includes(idx)) {
                this.collapse = this.collapse.filter(i => i !== idx);
            } else {
                this.collapse.push(idx);
            }
        },

        tumunuTemizle(){
            this.form = []
        },

        altsec(idx, checkAll){
            
            const parentId = this.abilities[idx].id
            let subIds = this.abilities[idx].sub.map(sub => sub.id);

            subIds.push(parentId)
            if (checkAll) 
            {
                subIds.forEach(subId => {
                    if (!this.form.includes(subId)) {
                        this.form.push(subId);
                    }
                });
            } else {


                this.form = this.form.filter(item => !subIds.includes(item));
            }
        },

        alttemizle(idx){
            let idsToRemove = this.abilities[idx].sub.map(e => e.id);
            idsToRemove.push( this.abilities[idx].id)
            this.form = this.form.filter(id => !idsToRemove.includes(id));
        },

        tumunuAc(){
            const scount = this.abilities.length 
            for (let i = 0; i < scount; i++) {
                this.collapse.includes(i) ? '' : this.collapse.push(i)
            }
            
        },

    },
};
</script>

<template>
<Layout>
  <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-md-5">
          <div class="card">
              <div class="card-body">
                  <div class="row">
                        <div class="col-md-12">
                            <div class="d-flex justify-content-between">
                                <a href="" v-if="abilities.length == collapse.length"  @click.prevent="collapse = []">Tümünü Daralt</a>
                                <a href="" v-else @click.prevent="tumunuAc()">Tümünü Aç</a>
                                <a href="" @click.prevent="tumunuTemizle()">Tümünü Temizle</a>
                            </div>
                            <ul class="file-tree" style="padding-left: 0;">
                                <li v-for="(ablty,i) in abilities" :key="i"  style="padding:3px 2px;border:solid 1px #0000002b;border-radius:5px;margin:5px 0px">

                                    <div @click.prevent="_collapse(i)"> 
                                        <a href=""  class="px-2 fs-5 float-start">{{ collapse.includes(i) ? '-' : '+' }}</a>
                                        <label  style="cursor: pointer;font-size:.9rem;margin-bottom:0px;margin-left:5px">{{ ablty.title }} Menüsü</label>
                                    </div>

                                    <ul v-if="collapse.includes(i)" class="px-4 py-2">
                                        <li class="text-start me-2 mb-3">
                                            <button class="btn btn-sm btn-outline-primary me-1" @click="altsec(i, true)">  Tümünü İşaretle</button> 
                                            <button class="btn btn-sm btn-outline-danger me-1" @click="alttemizle(i)">  Tümünü Kaldır</button> 
                                        </li>
                                        <li v-for="(sub, d) in ablty.sub" :key="d">
                                        
                                            <input type="checkbox" :checked="form.includes(sub.id)"  @click="handleCheckboxChange(sub.id)" :id="`file${sub.id}`"/>
                                            <label :for="`file${sub.id}`" style="cursor: pointer;margin-bottom: 0.2rem;margin-left:5px">{{ sub.title }}</label>
                                            
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                        <div class="col-md-12 mb-2">
                            <div class="input-group mb-3">
                                <input type="text" v-model="group_name" class="form-control" placeholder="Yetkilere bir isim verin" />
                                <div class="input-group-append">
                                   <button class="btn btn-warning" @click="handle()" type="button" v-if="update_id">Güncelle</button>
                                   <button class="btn btn-success" @click="handle(true)" type="button">Yeni Kaydet</button>
                                </div>
                            </div>
                        </div>
                  </div>
              </div>
          </div>
      </div>
      <div class="col-md-7">
        <div class="card">
            <div class="card-body">
                <div class="row d-flex flex-wrap mb-1">
                    <div class="responsive-table">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th>Grup Adı</th>
                                    <th>Yetki Sayısı</th>
                                    <th style="width:25px"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(prt, i) in list" :key="i">
                                    <td>{{ prt.name }}</td>
                                    <td>{{ prt.abilities.length }}</td>
                                    <td><button class="btn btn-sm btn-warning" @click="update(i)">Güncelle</button></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>
    <!-- end row-->
  </Layout>
</template>